import PropTypes from 'prop-types';
import React from 'react';

const SelectFormField = ({id, label, defaultValue, options, onChange}) => (
  <label htmlFor={id}>{label}
    <select id={id} defaultValue={defaultValue} onChange={onChange}>
      {options.map(({value, label}) =>
        <option key={value} value={value}>{label}</option>,
      )}
    </select>
  </label>
);

SelectFormField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,

};

export default SelectFormField;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/SelectFormField/index.js